import { render, staticRenderFns } from "./FormInputLabel.vue?vue&type=template&id=754aa6a3&scoped=true&"
import script from "./FormInputLabel.vue?vue&type=script&lang=js&"
export * from "./FormInputLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754aa6a3",
  null
  
)

export default component.exports